import {H3, Icon} from '@hm/fundamental'
import {mdiUnfoldLessHorizontal, mdiUnfoldMoreHorizontal} from '@mdi/js'
import {useTranslation} from 'react-i18next'

import {REPORT_FILTERS_WIDGET_NAMESPACE} from '../consts'

import {useFiltersCollapse} from './FiltersCollapseProvider'

interface FiltersHeaderProps {
  title: string
  toggleAllDataCy?: string
}

export const FiltersHeader = ({
  title,
  toggleAllDataCy = 'report_filters_toggle_all'
}: FiltersHeaderProps) => {
  const {t} = useTranslation(REPORT_FILTERS_WIDGET_NAMESPACE)
  const collapseContext = useFiltersCollapse()

  return (
    <div className="flex items-center justify-between mb-2">
      <H3>{title}</H3>
      {collapseContext && (
        <button
          className="flex items-center gap-1 text-sm text-gray-600 hover:text-gray-900 cursor-pointer border-none bg-transparent p-0"
          onClick={collapseContext.toggleAll}
          data-cy={toggleAllDataCy}
        >
          {collapseContext.allCollapsed ? (
            <>
              <Icon path={mdiUnfoldMoreHorizontal} />
              <span>{t('actions.expandAll')}</span>
            </>
          ) : (
            <>
              <Icon path={mdiUnfoldLessHorizontal} />
              <span>{t('actions.collapseAll')}</span>
            </>
          )}
        </button>
      )}
    </div>
  )
}
